module.exports = __webpack_public_path__ + "static/media/user-logo1.3992006d.png";